import { all, put, call, takeEvery } from 'redux-saga/effects'
import axios from 'axios'
import { getlocalstorage } from './../../../constants/local_storage'
//import { push } from "connected-react-router";

import * as actions from './actions'
import moment from 'moment'
import { timeZone } from '../../../lib/helper'

function* loadFueluse(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )
  const USER_ID = getlocalstorage(localStorage.getItem('profile'), 'id')

  const vehicle_visibility = getlocalstorage(
    localStorage.getItem('profile'),
    'vehicle_visibility',
  )

  const {
    data: {
      list_vehicle_id,
      vehicle_type_id,
      eventdate,
      vehicle_status,
      type_file,
    },
  } = action.payload
  const date_start = timeZone(
    moment(eventdate[0]['_d']).format('YYYY-MM-DD HH:mm'),
    'start',
  )
  const date_end = timeZone(
    moment(eventdate[1]['_d']).format('YYYY-MM-DD HH:mm'),
    'end',
  )

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/fueluse`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        company_id: COMPANY_ID,
        vehicle_type_id: vehicle_type_id.toString(),
        user_id: USER_ID,
        vehicle_status,
        type_file,
        vehicle_visibility,
      },
      //  { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } }
    )

    yield put(actions.loadFueluse.success(res.data))

    window.location = res.data.result
  } catch (err) {
    yield put(actions.loadFueluse.failure())
  }
}

function* loadFuelusepreview(action) {
  const {
    data: {
      list_vehicle_id,
      vehicle_type_id,
      date_start,
      date_end,
      vehicle_status,
      type_file,
      company_id,
      user_id,
      vehicle_visibility,
    },
  } = action.payload

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_API_REPORT_GOLANG}/reports/go/fueluse`,
      {
        date_start,
        date_end,
        list_vehicle_id,
        company_id,
        vehicle_type_id,
        user_id,
        vehicle_status,
        type_file,
        vehicle_visibility,
      },
    )

    yield put(actions.loadFueluse.success(res.data))
    window.location = res.data.result
  } catch (err) {
    yield put(actions.loadFueluse.failure())
  }
}

function* loadVehicle(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  const vehicle_visibility = getlocalstorage(
    localStorage.getItem('profile'),
    'vehicle_visibility',
  )

  const { vehicletypeID } = action.payload
  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getvehiclebygroupid`,
      {
        companyID: COMPANY_ID,
        vehicletypeID: vehicletypeID,
        allow_vehicles: vehicle_visibility,
      },
      { headers: { Authorization: `Bearer ${ACCESSTOKEN}` } },
    )
    yield put(actions.loadVehicle.success(res.data))
  } catch (err) {
    yield put(actions.loadVehicle.failure())
  }
}

function* loadVehicleType(action) {
  const ACCESSTOKEN = localStorage.getItem('access-token')
  const COMPANY_ID = getlocalstorage(
    localStorage.getItem('profile'),
    'company_id',
  )

  try {
    const res = yield call(
      axios.post,
      `${process.env.REACT_APP_LARAVEL_API_ENDPOINT}/getgroupvehicle`,
      {
        company_id: COMPANY_ID,
      },
      {
        headers: { Authorization: `Bearer ${ACCESSTOKEN}` },
      },
    )
    yield put(actions.loadVehicleType.success(res.data))
  } catch (err) {
    yield put(actions.loadVehicleType.failure())
  }
}

export default function* watchReportPoolState() {
  yield all([
    takeEvery(actions.LOAD_FUELUSE.REQUEST, loadFueluse),
    takeEvery(actions.LOAD_FUELUSE_PREVIEW.REQUEST, loadFuelusepreview),
    takeEvery(actions.LOAD_VEHICLE_FUELUSE.REQUEST, loadVehicle),
    takeEvery(actions.LOAD_VEHICLE_TYPE_FUELUSE.REQUEST, loadVehicleType),
  ])
}

export { loadFueluse, loadVehicle, loadVehicleType, loadFuelusepreview }
